// extracted by mini-css-extract-plugin
export default {"hidden":"an2vQ6"};